export const orders = {
  title: 'Megrendelések',
  subtitle: 'Megrendelések kezelése és nyomon követése',
  
  // Alapinformációk
  list: {
    title: 'Megrendelések listája',
    empty: 'Nincsenek megrendelések',
    loading: 'Megrendelések betöltése...',
    error: 'Hiba a megrendelések betöltésekor',
    searchPlaceholder: 'Keresés megrendelés száma, ügyfél neve vagy email szerint...',
    createNew: 'Új megrendelés',
    createNewSoon: 'Új megrendelés funkció hamarosan!'
  },

  // Táblázat fejlécek
  table: {
    number: 'Megrendelés száma',
    customer: 'Ügyfél',
    date: 'Dátum',
    status: 'Státusz',
    amount: 'Összeg',
    deliveryNote: 'Szállítólevél',
    actions: 'Műveletek'
  },

  // Státuszok
  status: {
    pending: 'Függőben',
    confirmed: 'Megerősítve',
    processing: 'Feldolgozás alatt',
    shipped: 'Szállítás alatt',
    delivered: 'Kiszállítva',
    cancelled: 'Törölve',
    completed: 'Befejezve'
  },

  // Műveletek
  actions: {
    view: 'Megtekintés',
    edit: 'Szerkesztés',
    delete: 'Törlés',
    createDeliveryNote: 'Szállítólevél létrehozása',
    updateStatus: 'Státusz frissítése'
  },

  // Statistikák
  stats: {
    total: 'Összes megrendelés',
    pending: 'Függőben lévő',
    confirmed: 'Megerősített',
    completed: 'Befejezett'
  },

  // Státusz szűrő
  filter: {
    all: 'Összes',
    pending: 'Függőben',
    confirmed: 'Megerősítve',
    processing: 'Feldolgozás alatt',
    shipped: 'Szállítás alatt',
    delivered: 'Kiszállítva',
    cancelled: 'Törölve',
    completed: 'Befejezve'
  },

  // Megrendelés részletek
  details: {
    title: 'Megrendelés részletei',
    basicInfo: 'Alapinformációk',
    customerInfo: 'Ügyfél információk',
    deliveryInfo: 'Szállítási információk',
    items: 'Megrendelési tételek',
    paymentInfo: 'Fizetési adatok',
    notes: 'Megjegyzések',
    systemInfo: 'Rendszer információk',
    documentChain: 'Bizonylat lánc'
  },

  // Megrendelés szerkesztés
  form: {
    title: 'Megrendelés szerkesztése',
    status: 'Státusz',
    requestedDeliveryDate: 'Kért szállítási dátum',
    confirmedDeliveryDate: 'Megerősített szállítási dátum',
    deliveryAddress: 'Szállítási cím',
    deliveryInstructions: 'Szállítási utasítások',
    paymentTerms: 'Fizetési feltételek',
    paymentMethod: 'Fizetési mód',
    notes: 'Megjegyzések',
    save: 'Mentés',
    cancel: 'Mégse',
    required: 'kötelező'
  },

  // Fizetési módok
  paymentMethods: {
    bankTransfer: 'Banki átutalás',
    cash: 'Készpénz',
    card: 'Bankkártya',
    check: 'Csekk'
  },

  // Mezők
  fields: {
    orderNumber: 'Megrendelés száma',
    customerName: 'Ügyfél neve',
    customerEmail: 'Ügyfél email',
    orderDate: 'Megrendelés dátuma',
    totalAmount: 'Teljes összeg',
    subtotal: 'Nettó összeg',
    currency: 'Pénznem',
    createdAt: 'Létrehozva',
    updatedAt: 'Módosítva',
    createdBy: 'Létrehozta'
  },

  // Üzenetek
  messages: {
    statusUpdated: 'Státusz sikeresen frissítve',
    orderUpdated: 'Megrendelés sikeresen frissítve',
    orderDeleted: 'Megrendelés sikeresen törölve',
    deliveryNoteCreated: 'Szállítólevél sikeresen létrehozva',
    confirmDelete: 'Biztosan törli ezt a megrendelést?',
    deleteWarning: 'Ez a művelet nem visszavonható!'
  },

  // Hibák
  errors: {
    loadFailed: 'Hiba a megrendelések betöltésekor',
    updateFailed: 'Hiba a megrendelés frissítésekor',
    deleteFailed: 'Hiba a megrendelés törlésekor',
    notFound: 'Megrendelés nem található',
    invalidData: 'Érvénytelen adatok'
  }
}; 